import { z } from 'zod';
import { createToolSignature, ToolSignature } from './tool-signature';

export const displayProfilesToolSignature = createToolSignature({
    name: 'displayProfilesTool',
    description:
        "Display a selection of profiles to the user as a table/list. It is a great way to present a larger list of contacts, or showing contacts that have not already been added to the system (such as when searching a users linkedin network or when displaying recommendations). The user can act on the displayed profiles in the UI that is generated by this tool. ALWAYS use this tool when you have looked up profiles rather than listing them manually. All arguments are REQUIRED. You MUST provide them. If you for instance don't have any linkedin profile urls, set the linkedinProfileUrls argument to an empty array.",
    inputSchema: z
        .object({
            memberIds: z
                .array(z.string())
                .describe(
                    'The linkedin memberIds of the contacts to display, associated with the contacts linkedin profile, can be empty',
                ),
            prospectIds: z
                .array(z.string())
                .describe(
                    'The prospectIds of the contacts to display. ProspectIds are associated with a contact (but different from the userContactId), prospectIds are a 24 character string of random letters and numbers that does not contain any hyphens and is not on the form of a uuid v4. Can be empty',
                ),
            linkedinProfileUrls: z
                .array(z.string())
                .describe(
                    'The linkedin profile urls of the contacts to display, on the format linkedin.com/in/.../, can be empty',
                ),
        })
        .describe(
            'Internal and external identifiers associated with the individual contacts to display. Only provide one identifier per contact to display, the preferred identifier is prospectId followed by memberId.',
        ),
    outputSchema: z.object({
        memberIds: z.array(z.string()).describe('The linkedin memberIds of the contacts to display'),
        prospectIds: z.array(z.string()).describe('The prospectIds of the contacts to display'),
        linkedinProfileUrls: z
            .array(z.string())
            .describe('The linkedin profile urls of the contacts to display, can be empty'),
    }),
    toolCallUi: (input) => null,
});
